import { useEffect, useState } from 'react';

const withFieldIndex = (fields: any[]) => fields.map((field, index) => ({ ...field, index }));

// Owns the active version's form-field definitions, its persisted input
// data, and whether it's a free-text "system prompt" version rather than a
// structured persona form.
export const useConfigurationFormFields = ({
  defaultTemplateFields,
  configurationSettingsPrompt,
  hasNoSettingsYet,
}: {
  defaultTemplateFields: any;
  configurationSettingsPrompt: any;
  hasNoSettingsYet: boolean;
}) => {
  const [formFields, setFormFields] = useState<any[] | null>(null);
  const [inputData, setInputData] = useState<any>(null);
  const [systemPromptActive, setSystemPromptActive] = useState(false);
  const [formFieldsObject, setFormFieldsObject] = useState<Record<string, any>>({});

  const resetToTemplateDefaults = () => {
    if (!defaultTemplateFields) {
      return;
    }

    setFormFields(withFieldIndex(defaultTemplateFields.form_fields));
    setInputData(null);
  };

  // Brand-new project: no versions exist yet, so seed the form with the
  // template's defaults.
  useEffect(() => {
    if (defaultTemplateFields && hasNoSettingsYet) {
      resetToTemplateDefaults();
    }
  }, [defaultTemplateFields, hasNoSettingsYet]);

  useEffect(() => {
    if (configurationSettingsPrompt) {
      if (!configurationSettingsPrompt.is_manual) {
        setSystemPromptActive(false);
        setFormFields(withFieldIndex(configurationSettingsPrompt.form_fields));
        setInputData(configurationSettingsPrompt.input_data);
      } else {
        setSystemPromptActive(true);
      }
    } else if (defaultTemplateFields) {
      resetToTemplateDefaults();
    }
  }, [configurationSettingsPrompt]);

  useEffect(() => {
    if (!formFields) {
      return;
    }

    setFormFieldsObject(
      formFields.reduce((prev: Record<string, any>, current) => {
        prev[current.key] = current;

        return prev;
      }, {}),
    );
  }, [formFields]);

  return {
    formFields,
    resetToTemplateDefaults,
    inputData,
    systemPromptActive,
    setSystemPromptActive,
    formFieldsObject,
  };
};
